var _a;
/** 上传区域 */
export var region = {
    z0: 'z0',
    z1: 'z1',
    z2: 'z2',
    na0: 'na0',
    as0: 'as0',
    cnEast2: 'cn-east-2'
};
/** 上传区域对应的 host */
export var regionUphostMap = (_a = {},
    _a[region.z0] = {
        srcUphost: ['up.qiniup.com'],
        cdnUphost: ['upload.qiniup.com']
    },
    _a[region.z1] = {
        srcUphost: ['up-z1.qiniup.com'],
        cdnUphost: ['upload-z1.qiniup.com']
    },
    _a[region.z2] = {
        srcUphost: ['up-z2.qiniup.com'],
        cdnUphost: ['upload-z2.qiniup.com']
    },
    _a[region.na0] = {
        srcUphost: ['up-na0.qiniup.com'],
        cdnUphost: ['upload-na0.qiniup.com']
    },
    _a[region.as0] = {
        srcUphost: ['up-as0.qiniup.com'],
        cdnUphost: ['upload-as0.qiniup.com']
    },
    _a[region.cnEast2] = {
        srcUphost: ['up-cn-east-2.qiniup.com'],
        cdnUphost: ['upload-cn-east-2.qiniup.com']
    },
    _a);
//# sourceMappingURL=region.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_qiniu-js@3.4.1@qiniu-js/esm/config/region.js
// module id = 1269
// module chunks = 362